import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap

		let $header = $('.contact-side-header > h3')[0]
		if ($header) {
			gsap.fromTo(
				'.contact-side-header > h3',
				{
					x: -15,
					opacity: 0,
				},
				{
					scrollTrigger: '.contact-side-header > h3',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}

		let $contactInfo = $('.side-item')
		if ($contactInfo.length) {
			document.querySelectorAll('.side-item').forEach((item) => {
				gsap.fromTo(
					item,
					{ x: 15, opacity: 0 },
					{
						scrollTrigger: item,
						delay: 0.5,
						duration: 0.5,
						x: 0,
						opacity: 1,
					}
				)
			})
		}

		let $form = $('.gform_wrapper')[0]
		if ($form) {
			gsap.fromTo(
				'.gform_wrapper',
				{
					opacity: 0,
				},
				{
					scrollTrigger: '.gform_wrapper',
					delay: 0.75,
					duration: 0.5,

					opacity: 1,
				}
			)
		}

		let $plane = $('.contact-plane')[0]
		if ($plane) {
			gsap.fromTo(
				'.contact-plane',
				{
					y: -250,
					opacity: 0,
				},
				{
					scrollTrigger: '.contact-plane',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}

		let $iframe = $('.contact-iframe')[0]
		if ($iframe) {
			gsap.fromTo(
				'.contact-iframe',
				{
					x: -250,
					opacity: 0,
				},
				{
					scrollTrigger: '.contact-iframe',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
	},
}
